import { flushSync } from 'react-dom';
import { createRoot } from 'react-dom/client';
import React from 'react';

export default (editor) => {
  const domc = editor.Components;
  const defType = domc.getType('default');
  const defModel = defType.model;
  const wrpChld = 'data-chld';

  // Main React component
  domc.addType('react-component', {
    model: {
      toHTML(opts = {}) {
        let props = JSON.stringify(this.getAttrToHTML());
        props = this.escapeHTML(props);

        let klass = this.get('type');
        let attributes = {
          'data-react-class': klass,
          'data-react-props': JSON.stringify(props),
          'data-react-cache-id': `${klass}-${this.ccid}`
        };

        return `<div data-react-class="${klass}" data-react-props="${props}" data-react-cache-id="${klass}-${this.ccid}"></div>`;
      },
      escapeHTML(string) {
        return string.replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;");
      }
    },
    view: {
      tagName: 'div',

      init() {
        const { model } = this;
        this.listenTo(model, 'change:attributes', this.render);
        this.listenTo(model.components(), 'add remove reset', this.__upRender);
      },

      getChildrenContainer() {
        const { childrenContainer } = this;
        if (childrenContainer) return childrenContainer;

        this.childrenContainer = document.createElement('childc');

        return this.childrenContainer;
      },

      /**
       * We need this container to understand if the React component is able
       * to render children
       */
      createReactChildWrap() {
        return React.createElement('span', { [wrpChld]: true });
      },

      createReactEl(cmp, props) {
        return React.createElement(cmp, props, this.createReactChildWrap());
      },

      mountReact(cmp, el) {
        // A React 18 root is bound to the element it was created for. Create one on first
        // mount, and recreate it if the target element changed, so we never render into a
        // stale/detached container. flushSync on (re)create keeps the commit synchronous so
        // the querySelector in render() below sees the mounted children container.
        if (!this._reactRoot || this._reactRootEl !== el) {
          if (this._reactRoot) this._reactRoot.unmount();
          this._reactRoot = createRoot(el);
          this._reactRootEl = el;
          flushSync(() => this._reactRoot.render(cmp));
          return;
        }

        this._reactRoot.render(cmp);
      },

      render() {
        const { model, el } = this;
        this.updateAttributes();
        this.renderChildren();
        const reactEl = this.createReactEl(model.get('component'), {
          ...model.get('attributes')
        });
        this.mountReact(reactEl, el);
        const chld = el.querySelector(`span[${wrpChld}]`);

        // If the container is found, the react component is able to render children
        if (chld) {
          const chldCont = this.getChildrenContainer();
          while (chldCont.firstChild) {
            chld.appendChild(chldCont.firstChild);
          }
        }

        return this;
      },

      __upRender() {
        clearTimeout(this._upr);
        this._upr = setTimeout(() => this.render());
      },

      onRemove() {
        // Tear down the cached React root so the detached DOM node isn't left hosting a
        // live root (which would warn "container already has a root" if GrapesJS reuses it).
        clearTimeout(this._upr);
        if (this._reactRoot) {
          this._reactRoot.unmount();
          this._reactRoot = null;
          this._reactRootEl = null;
        }
      }
    }
  });
};
